import React, { useState, useCallback } from 'react';
import InventoryGrid from './InventoryGrid';
import InventoryScanner from './InventoryScanner';
import IssyBanner from './IssyBanner';
import { IconScan } from './Icons';

/**
 * Wraps InventoryGrid with a "Scan Sheet" tab so users can
 * photograph a physical count sheet on any inventory page.
 */
export default function InventoryPage({ title = 'Inventory', filterFood }) {
  const [tab, setTab] = useState('list'); // 'list' | 'scan'
  const [refreshKey, setRefreshKey] = useState(0);

  const handleApplied = useCallback(() => {
    // After applying a scan, switch to list and force a refresh
    setTab('list');
    setRefreshKey(k => k + 1);
  }, []);

  return (
    <>
      <div className="page-header">
        <span className="page-title">{title}</span>
      </div>

      <div className="page-body">
        {tab === 'scan' ? (
          <>
            <button
              onClick={() => setTab('list')}
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#64748b', fontSize: 13, marginBottom: 16, padding: 0,
              }}
            >
              ← Back to inventory list
            </button>
            <InventoryScanner onApplied={handleApplied} />
          </>
        ) : (
          <>
            <IssyBanner />

            {/* Prominent scan card */}
            <div
              onClick={() => setTab('scan')}
              style={{
                display: 'flex', alignItems: 'center', gap: 16,
                background: 'linear-gradient(135deg, rgba(13,148,136,0.12) 0%, rgba(18,207,196,0.06) 100%)',
                border: '1.5px dashed rgba(13,148,136,0.4)',
                borderRadius: 12, padding: '16px 20px',
                cursor: 'pointer', marginBottom: 20,
                transition: 'border-color .15s, background .15s',
              }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(13,148,136,0.8)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(13,148,136,0.4)'}
            >
              <div style={{
                width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                background: '#0D9488', display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <IconScan width={22} height={22} stroke="#fff" />
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 2 }}>Scan Walk-in or Count Sheet</div>
                <div style={{ fontSize: 13, color: '#64748b' }}>Take a photo of your inventory — AI reads it and updates counts automatically</div>
              </div>
              <div style={{ marginLeft: 'auto', color: '#0D9488', fontSize: 20 }}>→</div>
            </div>

            <InventoryGrid key={refreshKey} filterFood={filterFood} />
          </>
        )}
      </div>
    </>
  );
}
